module.exports = require('./src').locale2();